// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { convertToProjectList as convertQuote, CreateProjectList } from "@bg/App/Services/QuoteService";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";

interface Props {
    apiParameter: CreateProjectList;
    apiResult: { successful: boolean; error?: any; wishListId?: string | undefined };
}

type Parameter = CreateProjectList & {
    onSuccess?: () => void;
    onComplete?: (result: any) => void;
    onError?: (e: any) => void;
};

type HandlerType = Handler<Parameter, Props>;

export const BeginCreatingProjectList: HandlerType = props => {
    props.dispatch({
        type: "commonActionSetter/SetAction",
        payload: {
            name: "isLoading",
            value: true,
        },
    } as any);
};

export const DispatchBeginAction: HandlerType = props => {
    props.apiParameter = {
        ...props.parameter,
    };
};

export const CallApiWithParameters: HandlerType = async props => {
    props.apiResult = await convertQuote(props.apiParameter);
};

export const OnError: HandlerType = props => {
    if (!props.apiResult.successful) {
        props.dispatch({
            type: "commonActionSetter/SetAction",
            payload: {
                name: "isLoading",
                value: false,
            },
        } as any);
        props.parameter.onError?.(props.apiResult.error);
    }
};

export const RedirectOnComplete: HandlerType = props => {
    if (props.apiResult.successful && props.apiResult.wishListId) {
        props.dispatch({
            type: "commonActionSetter/SetAction",
            payload: {
                name: "isLoading",
                value: false,
            },
        } as any);
        const wishListPageUrl = getPageLinkByPageType(props.getState(), "MyListsDetailsPage")?.url;
        if (wishListPageUrl) {
            window.location.href = `${wishListPageUrl}?id=${props.apiResult.wishListId}`;
        }
    }
};

export const chain = [
    BeginCreatingProjectList,
    DispatchBeginAction,
    CallApiWithParameters,
    OnError,
    RedirectOnComplete,
];

const convertToProjectList = createHandlerChainRunner(chain, "ConvertToProjectList");
export default convertToProjectList;
